import React from 'react'

const ReportDetail = () => {
  return (
    <div class="min-h-screen bg-gray-50 p-6">

    
    <div class="flex items-center justify-between mb-6">
      <h1 class="text-xl font-semibold">Dashboard</h1>
      <div class="flex items-center space-x-2">
        <input type="text" placeholder="Search" class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
        <button class="flex items-center bg-white border rounded-lg px-4 py-2 shadow text-sm">
          ⬆️ Import
        </button>
        <button class="flex items-center bg-white border rounded-lg px-4 py-2 shadow text-sm">
          ⬇️ Export
        </button>
      </div>
    </div>
  
    
    <div class="bg-white border rounded-xl p-4 flex justify-between items-center mb-6">
      <div>
        <h2 class="font-semibold">December 2024</h2>
        <p class="text-gray-500 text-sm">Here are the details of this year’s finflow monthly report</p>
      </div>
      <button class="border rounded-lg px-4 py-2 text-sm shadow">⚙️ Filter</button>
    </div>
  
    
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
      
      <div class="bg-white p-5 rounded-xl shadow border">
        <div class="flex items-center space-x-3">
          <div class="bg-blue-100 text-blue-600 p-3 rounded-lg">💰</div>
          <div>
            <p class="text-sm text-gray-500">Total Revenue</p>
            <h3 class="text-xl font-bold">$1,200,000</h3>
            <span class="text-green-500 text-xs">+16% last month</span>
          </div>
        </div>
      </div>
  
      
      <div class="bg-white p-5 rounded-xl shadow border">
        <div class="flex items-center space-x-3">
          <div class="bg-blue-100 text-blue-600 p-3 rounded-lg">💳</div>
          <div>
            <p class="text-sm text-gray-500">Net Profit</p>
            <h3 class="text-xl font-bold">$250,000</h3>
            <span class="text-green-500 text-xs">+8% over month</span>
          </div>
        </div>
      </div>
  
      
      <div class="bg-white p-5 rounded-xl shadow border">
        <div class="flex items-center space-x-3">
          <div class="bg-blue-100 text-blue-600 p-3 rounded-lg">📦</div>
          <div>
            <p class="text-sm text-gray-500">Expenses</p>
            <h3 class="text-xl font-bold">$950,000</h3>
            <span class="text-green-500 text-xs">+6% last month</span>
          </div>
        </div>
      </div>
  
      
      <div class="bg-white p-5 rounded-xl shadow border">
        <div class="flex items-center space-x-3">
          <div class="bg-blue-100 text-blue-600 p-3 rounded-lg">💵</div>
          <div>
            <p class="text-sm text-gray-500">Cash Flow</p>
            <h3 class="text-xl font-bold">$860,000</h3>
            <span class="text-green-500 text-xs">+16% last month</span>
          </div>
        </div>
      </div>
    </div>
  
    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
  
      
      <div class="bg-white p-5 rounded-xl shadow border">
        <h3 class="font-semibold mb-4">Monthly Earnings Breakdown</h3>
        <table class="w-full text-sm text-left">
          <thead>
            <tr class="text-gray-500">
              <th class="pb-2">Category</th>
              <th class="pb-2">Source</th>
              <th class="pb-2">Amount</th>
              <th class="pb-2 text-right">Percentage of Total</th>
            </tr>
          </thead>
          <tbody class="divide-y">
            <tr>
              <td class="py-2">Employment</td>
              <td>Salary</td>
              <td>$4,500</td>
              <td class="text-right">55%</td>
            </tr>
            <tr>
              <td class="py-2">Investments</td>
              <td>Rental Property</td>
              <td>$1,200</td>
              <td class="text-right">15%</td>
            </tr>
            <tr>
              <td class="py-2">Entrepreneurship</td>
              <td>Online Store Sales</td>
              <td>$1,000</td>
              <td class="text-right">12%</td>
            </tr>
            <tr>
              <td class="py-2">Savings Returns</td>
              <td>Interest Earnings</td>
              <td>$800</td>
              <td class="text-right">8%</td>
            </tr>
            <tr>
              <td class="py-2">Project Base</td>
              <td>Project Salary</td>
              <td>$1,450</td>
              <td class="text-right">12%</td>
            </tr>
          </tbody>
        </table>
      </div>
  
      
      <div class="bg-white p-5 rounded-xl shadow border">
        <div class="flex justify-between items-center mb-4">
          <h3 class="font-semibold">Monthly Income</h3>
          <div class="flex items-center space-x-2 text-gray-400">
            <button>✏️</button>
            <button>⋮</button>
          </div>
        </div>
        <h2 class="text-3xl font-bold mb-1">$25,653.00</h2>
        <p class="text-green-500 text-sm mb-4">+12% vs last years</p>
  
        
        <div class="flex items-end justify-between h-40 mb-4">
          <div class="w-8 bg-gray-200 rounded-t-lg h-16"></div>
          <div class="w-8 bg-gray-200 rounded-t-lg h-24"></div>
          <div class="w-8 bg-gray-200 rounded-t-lg h-20"></div>
          <div class="w-8 bg-blue-500 rounded-t-lg h-32 relative">
            <span class="absolute -top-6 left-1/2 -translate-x-1/2 text-xs bg-black text-white px-2 py-1 rounded">$20,192</span>
          </div>
          <div class="w-8 bg-gray-200 rounded-t-lg h-14"></div>
          <div class="w-8 bg-gray-200 rounded-t-lg h-10"></div>
          <div class="w-8 bg-gray-200 rounded-t-lg h-12"></div>
        </div>
  
        
        <div class="flex space-x-4 text-sm text-gray-600">
          <div class="flex items-center space-x-1">
            <span class="w-3 h-3 bg-yellow-400 rounded-full"></span> <span>Active Income</span>
          </div>
          <div class="flex items-center space-x-1">
            <span class="w-3 h-3 bg-blue-400 rounded-full"></span> <span>Passive Income</span>
          </div>
          <div class="flex items-center space-x-1">
            <span class="w-3 h-3 bg-orange-400 rounded-full"></span> <span>Business Income</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  )
}

export default ReportDetail
